<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-lg" style="width:90vw; min-height: 80vh">
      <div class="modal-content " style="margin: 0 auto; height:100%">
        <div class="modal-header w-100">
          <div class="float-left upload-lf">Projekte von {{useritem.firstname}} {{useritem.lastname}}</div>
          <div class="float-right">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closemodal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body upload-body" style="height:80vh; overflow: auto">

          <table class="w-100 table ">
            <thead>
            <tr>
              <th></th>
              <th>Projektname</th>
              <th>Kurzname</th>
              <th>Projekt-Nr.</th>
              <th>Ort</th>
              <th>Rechte</th>
              <th>Zugewiesen am</th>
              <th>Status</th>
              <th></th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="(item,index) in customeruserprojects">
              <td>{{ item.projectid }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.shortname }}</td>
              <td>{{ item.number }}</td>
              <td>{{ item.city }}</td>
              <td>
                <select name="" v-model="item.pdroleid" class="form-control form-control-sm" @change="setCustomerProjectRole($event, item)">
                  <option :value="0">Ersteller</option>
                  <option :value="1">Admin</option>
                  <option :value="2">Benutzer</option>
                  <option :value="3">Gast</option>
                </select></td>
              <td>
                {{ getdateadded(item)}}
              </td>
              <td>
                <div class="switch ">
                  <label class="">
                    <input type="checkbox" :id="'creator' + item.pduserid" class="custom-control-input" v-model="item.active" :true-value="1" :false-value="0" @change="setCustomerProjectStatus($event, item)">
                    <span class="lever float-right mr-0"></span>
                  </label>
                </div>
              </td>
              <td>
<!--                <a href="#" @click=""><i class="fa fa-trash"></i></a>-->
              </td>
            </tr>
            </tbody>
          </table>


        </div>
      </div>
    </div>
  </div>


</template>
<script>

import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import moment from 'moment/moment'

export default{
  data () {
    return {
      'customeruserprojects': [],
      localtoast: null
    }
  },
  props: ['useritem', 'showmodal','customerid'],
  mounted () {
    console.log('Modal Mounted!')
    this.getCustomerUserProjects()
  },
  methods: {

    getdateadded(item) {
      let returndate = moment(item.added)
      if(!returndate.isValid()) {
        returndate = moment(item.created)
      }
      return returndate.format('DD.MM.YYYY')
    },

    closemodal() {
      this.$emit('closeModal')
    },
    async getCustomerUserProjects () {
      let _this = this
      console.log('get CustomerUserProjects', this.customerid, this.useritem.pduserid)

      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid, _this.useritem.pduserid],
        serviceName: "ProjectdocuCustomer",
        methodName: "getcustomeruserprojects"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
          _this.customeruserprojects = response.data.projects
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },

    async setCustomerProjectStatus (event, item) {
      console.log('ToDo: Set Customer Project Status', item, item.active)
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid, item.projectid, _this.useritem.pduserid, item.active],
        serviceName: "ProjectdocuCustomer",
        methodName: "setCustomerUserProjectActive"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        if(response.data == true) {
          _this.localtoast = _this.$toast(
            'Gespeichert.',
            {
              timeout: 2000,
              closeOnClick: true,
              toastClassName: "savenote",
            }
          )
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },
    async setCustomerProjectRole (event, item) {
      console.log('ToDo: Set Customer Project Role', item, item.pdroleid)
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid, item.projectid, _this.useritem.pduserid, item.pdroleid],
        serviceName: "ProjectdocuCustomer",
        methodName: "setCustomerProjectRole"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log('RESP', response)
        if(response.data == true) {
          _this.localtoast = _this.$toast(
            'Gespeichert.',
            {
              timeout: 2000,
              closeOnClick: true,
              toastClassName: "savenote",
            }
          )
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    }

  }
}

</script>



// WEBPACK FOOTER //
// src/components/customer/components/ProjectsModal.vue